import { useEffect } from "react"

const useOutsideElementAlerter = (ref: any, setShow: any, excludeId?: any, disabled?: boolean) => {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event: any) => {
            if (disabled) return
            if (ref.current && !ref.current.contains(event.target) && event.target.id !== excludeId) {
                setShow(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [ref, disabled])
}

export default useOutsideElementAlerter
